var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrap"},[_c('iframe',{ref:"iframe",attrs:{"src":`https://www.youtube.com/embed/${_vm.ytId}`,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }